import { render, staticRenderFns } from "./RubricSalInvoiceModal.vue?vue&type=template&id=77f96ec2&scoped=true&"
import script from "./RubricSalInvoiceModal.vue?vue&type=script&lang=js&"
export * from "./RubricSalInvoiceModal.vue?vue&type=script&lang=js&"
import style0 from "./RubricSalInvoiceModal.vue?vue&type=style&index=0&id=77f96ec2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f96ec2",
  null
  
)

export default component.exports